<template>
  <div v-if="isLoading || !isEdit || !empty(categoryInfo)">
    <a-card class="style1 category w-100" :class="[isDesktop ? 'desktop' : 'mobile']">
      <a-form :form="form" :label-col="isDesktop ? { span: 4 } : {}" :wrapper-col="isDesktop ? { span: 20 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
        <a-form-item label="Name">
          <a-input
            @change="onGenerateSlug"
            v-decorator="[
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input category name!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Slug">
          <a-input
            v-decorator="[
              'slug',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input category slug!',
                  },
                ],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Super Category">
          <a-input v-decorator="['supercategory']" />
        </a-form-item>
        <a-form-item label="Description">
          <wysiwyg
            v-model="description"
            v-decorator="[
              'description',
              {
                rules: [
                  {
                    required: true,
                    validator: (rule, value, callback) => validateInput(rule, value, callback, 'Please input Description!'),
                  },
                ],
              },
            ]"
          />
          <!-- <a-input
            v-decorator="['address', { rules: [{ required: true, message: 'Please input your address!' }] }]"
          />-->
        </a-form-item>
        <a-form-item label="Background">
          <a-upload
            v-decorator="['background']"
            action
            list-type="picture-card"
            :file-list="background"
            :before-upload="beforeUpload"
            @preview="file => handlePreview(file, 'background')"
            @change="({ fileList }) => handleChange({ fileList }, 'background')"
            class="background"
          >
            <div v-if="background.length === 0">
              <a-icon type="plus" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="Thumbnail">
          <a-upload
            v-decorator="['thumbnail']"
            action
            list-type="picture-card"
            :file-list="thumbnail"
            :before-upload="beforeUpload"
            @preview="file => handlePreview(file, 'thumbnail')"
            @change="({ fileList }) => handleChange({ fileList }, 'thumbnail')"
            class="thumbnail"
          >
            <div v-if="thumbnail.length === 0">
              <a-icon type="plus" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="Embed Icon">
          <a-upload
            v-decorator="['embed_icon']"
            action
            list-type="picture-card"
            :file-list="embedIcon"
            :before-upload="beforeUpload"
            @preview="file => handlePreview(file, 'embed_icon')"
            @change="({ fileList }) => handleChange({ fileList }, 'embed_icon')"
            class="embed_icon"
          >
            <div v-if="embedIcon.length === 0">
              <a-icon type="plus" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="Embed Thumbnail">
          <a-upload
            v-decorator="['embed_thumbnail']"
            action
            list-type="picture-card"
            :file-list="embedThumbnail"
            :before-upload="beforeUpload"
            @preview="file => handlePreview(file, 'embed_thumbnail')"
            @change="({ fileList }) => handleChange({ fileList }, 'embed_thumbnail')"
            class="embed_thumbnail"
          >
            <div v-if="embedThumbnail.length === 0">
              <a-icon type="plus" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="Player Embed">
          <a-row :gutter="20">
            <a-col :span="isDesktop ? 8 : 24">
              <a-textarea v-decorator="['playerembed']" :rows="10" @change="onChangePlayerEmbed" />
              <a-button type="primary" :disabled="empty(playerembed)" @click.prevent="showEmbedPreview">{{ showPreview ? 'Hide preview' : 'Preview' }}</a-button>
            </a-col>
            <a-col :span="isDesktop ? 16 : 24">
              <div v-if="showPreview" v-html="playerembed"></div>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="Order">
          <a-tooltip title="If you leave this blank or set to 0, it will order by name.">
            <a-input-number :min="0" :step="1" v-decorator="['order']" />
          </a-tooltip>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
          <a-tag color="red" class="d-block p-1" v-if="!empty(error)">{{ error }}</a-tag>
          <a-button type="primary" html-type="submit" :loading="isLoading">{{ isEdit ? 'Update category' : 'Create category' }}</a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-modal :visible="previewVisible" :closable="false" class="editProfile">
      <a-spin v-if="isLoadingCropper" size="large" />
      <cropper
        v-if="previewImage != null && !fixCroppedImageSize"
        ref="cropper"
        class="cropper"
        :src="previewImage"
        @change="change"
        @ready="onCropperReady"
        :defaultSize="defaultSize"
        :defaultPosition="defaultPosition"
      />
      <cropper
        v-if="previewImage != null && fixCroppedImageSize"
        ref="cropper"
        class="cropper"
        :src="previewImage"
        @change="change"
        @ready="onCropperReady"
        :stencil-size="{ width: 350, height: 200 }"
        :stencil-props="{ aspectRatio: 1.75 }"
      />
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Return</a-button>
        <a-button key="submit" type="primary" @click="handleOk">Submit</a-button>
      </template>
    </a-modal>
    <Loading :isLoading="isLoading" :type="typeLoading" :percent="percentLoading" />

    <template v-if="isEdit && !empty(categoryInfo)">
      <h2 class="text-left block w-100 m-3">Answers</h2>
      <Answer :data="categoryInfo.answers || []" class="w-100" @onDelete="doGetCategoryInfo($route.params.categorySlug)" />
      <h2 class="text-left block w-100 m-3">Testimonials</h2>
      <Testimonial :category="categoryInfo.id" class="w-100" />
    </template>
  </div>
  <div v-else>
    <h2>Category not found</h2>
    <a-button type="primary" class="mb-3" @click="$router.push({ name: 'AdminCategory' })">Go to categories list</a-button>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Cropper } from 'vue-advanced-cropper';
import Uploader from '@/services/UploadService';
import AdminService from '@/services/AdminService';
import Loading from '@/views/profile/loading';
import Answer from '@/views/admin/answer/list';
import Testimonial from '@/views/admin/testimonial/list';
import { empty, slugData, getBase64 } from '@/utils';
import { get } from 'lodash';
export default {
  components: {
    Cropper,
    Loading,
    Answer,
    Testimonial,
  },
  data() {
    return {
      error: '',
      categoryInfo: {},
      isLoading: false,
      imagePickerVisible: false,
      previewVisible: false,
      isLoadingCropper: false,
      previewImage: '',
      embedIcon: [],
      embedThumbnail: [],
      background: [],
      thumbnail: [],
      imgLocation: '',
      imageCropped: '',
      hasChange: {},
      hasCropped: {},
      name: '',
      description: '',
      playerembed: '',
      showPreview: false,
      typeLoading: 'submit',
      percentLoading: 0,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: 'category',
    });
  },
  computed: {
    ...mapState(['settings']),
    isEdit() {
      return this.$route.name === 'AdminCategoryDetail';
    },
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    fixCroppedImageSize() {
      return this.imgLocation === 'thumbnail' || this.imgLocation === 'embed_icon' || this.imgLocation === 'embed_thumbnail';
    },
  },
  watch: {
    $route: {
      handler(route) {
        if (this.isEdit) {
          this.doGetCategoryInfo(route.params.categorySlug);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$title = this.$route.meta.title;
  },
  methods: {
    empty,
    onGenerateSlug() {
      if (this.settings.locale === 'en') {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            slug: slugData(this.form.getFieldValue('name'), '-'),
          });
        });
      }
    },
    async doGetCategoryInfo(cateId) {
      try {
        this.isLoading = true;
        const resp = await AdminService.category.get(cateId);
        this.categoryInfo = resp[0];
        this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },

    async doInitData() {
      if (this.isEdit) {
        this.name = this.categoryInfo.name;
        this.description = this.categoryInfo.description;
        this.playerembed = this.categoryInfo.playerembed;
        this.showPreview = !empty(this.categoryInfo.playerembed);
        this.embedIcon = [];
        this.embedThumbnail = [];
        this.background = [];
        this.thumbnail = [];
        // eslint-disable-next-line camelcase
        const { embed_icon, embed_thumbnail, background, thumbnail } = this.categoryInfo;
        if (!empty(embed_icon)) {
          this.embedIcon.push({
            uid: '-1',
            status: 'done',
            name: this.getFileName(embed_icon),
            url: embed_icon,
          });
        }
        if (!empty(embed_thumbnail)) {
          this.embedThumbnail.push({
            uid: '-1',
            status: 'done',
            name: this.getFileName(embed_thumbnail),
            url: embed_thumbnail,
          });
        }
        if (!empty(background)) {
          this.background.push({
            uid: '-1',
            status: 'done',
            name: this.getFileName(background),
            url: background,
          });
        }
        if (!empty(thumbnail)) {
          this.thumbnail.push({
            uid: '-1',
            status: 'done',
            name: this.getFileName(thumbnail),
            url: thumbnail,
          });
        }
        if (this.settings.locale === 'es') {
          this.name = this.categoryInfo.name_es;
          this.description = this.categoryInfo.description_es;
        } else if (this.settings.locale === 'fr') {
          this.name = this.categoryInfo.name_fr;
          this.description = this.categoryInfo.description_fr;
        } else if (this.settings.locale === 'ko') {
          this.name = this.categoryInfo.name_ko;
          this.description = this.categoryInfo.description_ko;
        }
        this.isLoading = false;
        this.$nextTick(() => {
          this.form.setFieldsValue({
            name: this.name,
            slug: this.categoryInfo.slug,
            supercategory: this.categoryInfo.supercategory,
            description: this.description,
            thumbnail: this.thumbnail[0],
            background: this.background[0],
            playerembed: this.playerembed,
            embed_icon: this.embedIcon[0],
            embed_thumbnail: this.embedThumbnail[0],
            order: this.categoryInfo.order,
          });
        });
      }
    },
    defaultSize() {
      return {
        width: 10000,
        height: 10000,
        minHeight: 250,
        minWidth: 190,
      };
    },
    validateInput(rule, value, callback, message) {
      if (empty(value) || value === '<br>') {
        return callback(message);
      }
      callback();
    },
    defaultPosition() {
      return {
        left: 0,
        top: 0,
      };
    },
    getFileName(path) {
      let fileName = '';
      // eslint-disable-next-line no-useless-escape
      const patt = /\/([^\\\/:*\"<>|]+)$/g;
      const n = patt.exec(path);
      if (n !== null) {
        fileName = n[1];
      }
      return fileName;
    },
    change({ canvas }) {
      if (canvas) {
        if (this.fixCroppedImageSize && canvas.width !== 350) {
          const newCanvas = document.createElement('canvas');
          newCanvas.width = 350;
          newCanvas.height = 200;
          const newCtx = newCanvas.getContext('2d');
          newCtx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, newCanvas.width, newCanvas.height);
          canvas = newCanvas;
        }

        this.imageCropped = canvas.toDataURL('image/jpeg');
      }
    },
    handleUploadProgressing(percent, location) {
      this.percentLoading = percent;
      this.typeLoading = location;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            this.error = '';
            // upload image
            // Profile Banner Picture
            const dataSubmit = {};
            dataSubmit['locale'] = this.settings.locale;
            if (this.hasChange['background'] || this.hasCropped['background']) {
              if (empty(this.background)) {
                dataSubmit['background'] = '';
              } else {
                this.handleUploadProgressing(0, 'Background');
                // Background
                const backgroundContent = this.background[0];
                let background = {
                  contentType: backgroundContent.type, // you can set it based on the type of image you are uploading like image/png
                  fileName: backgroundContent.name,
                  file: backgroundContent.preview,
                };
                const respbackground = await new Uploader().uploadImage(background, percent => this.handleUploadProgressing(percent, 'Background'));
                dataSubmit['background'] = respbackground.Location;
              }
            } else if (!empty(values['background'])) {
              dataSubmit['background'] = values['background'].url;
            }

            if (this.hasChange['thumbnail'] || this.hasCropped['thumbnail']) {
              if (empty(this.thumbnail)) {
                dataSubmit['thumbnail'] = '';
              } else {
                this.handleUploadProgressing(0, 'Thumbnail');
                const thumbnailContent = this.thumbnail[0];
                let thumbnail = {
                  contentType: thumbnailContent.type, // you can set it based on the type of image you are uploading like image/png
                  fileName: thumbnailContent.name,
                  file: thumbnailContent.preview,
                };
                const respthumbnail = await new Uploader().uploadImage(thumbnail, percent => this.handleUploadProgressing(percent, 'Thumbnail'));
                dataSubmit['thumbnail'] = respthumbnail.Location;
              }
            } else if (!empty(values['thumbnail'])) {
              dataSubmit['thumbnail'] = values['thumbnail'].url;
            }

            if (this.hasChange['embed_icon'] || this.hasCropped['embed_icon']) {
              if (empty(this.embedIcon)) {
                dataSubmit['embed_icon'] = '';
              } else {
                this.handleUploadProgressing(0, 'Embed Icon');
                const embedIconContent = this.embedIcon[0];
                let embedIcon = {
                  contentType: embedIconContent.type, // you can set it based on the type of image you are uploading like image/png
                  fileName: embedIconContent.name,
                  file: embedIconContent.preview,
                };
                const respembedIcon = await new Uploader().uploadImage(embedIcon, percent => this.handleUploadProgressing(percent, 'Embed Icon'));
                dataSubmit['embed_icon'] = respembedIcon.Location;
              }
            } else if (!empty(values['embed_icon'])) {
              dataSubmit['embed_icon'] = values['embed_icon'].url;
            }

            if (this.hasChange['embed_thumbnail'] || this.hasCropped['embed_thumbnail']) {
              if (empty(this.embedThumbnail)) {
                dataSubmit['embed_thumbnail'] = '';
              } else {
                this.handleUploadProgressing(0, 'Embed Thumbnail');
                const embedThumbnailContent = this.embedThumbnail[0];
                let embedThumbnail = {
                  contentType: embedThumbnailContent.type, // you can set it based on the type of image you are uploading like image/png
                  fileName: embedThumbnailContent.name,
                  file: embedThumbnailContent.preview,
                };
                const respembedThumbnail = await new Uploader().uploadImage(embedThumbnail, percent => this.handleUploadProgressing(percent, 'Embed Thumbnail'));
                dataSubmit['embed_thumbnail'] = respembedThumbnail.Location;
              }
            } else if (!empty(values['embed_thumbnail'])) {
              dataSubmit['embed_thumbnail'] = values['embed_thumbnail'].url;
            }

            const paramsRequired = ['description', 'playerembed', 'name', 'slug', 'supercategory', 'order'];

            paramsRequired.forEach(item => {
              if (!empty(values[item])) {
                dataSubmit[item] = values[item];
              }
            });

            this.typeLoading = 'submit';
            if (!this.isEdit) {
              await AdminService.category.create(dataSubmit);
              this.$notification['success']({
                message: 'Create successful.',
                description: `${dataSubmit.name} was created successfully.`,
              });
            } else {
              await AdminService.category.update(this.categoryInfo.id, dataSubmit);
              this.$emit('onSuccess');
              this.$notification['success']({
                message: 'Update successful.',
                description: `${dataSubmit.name} was updated successfully.`,
              });
            }
            this.$router.push({ name: 'AdminCategory' });
          } catch (error) {
            console.log(error);
            this.error = get(error, 'response.data.error', error.message);
          } finally {
            this.isLoading = false;
          }
        } else {
          window.parent.scrollTo(0, 0);
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
      this.imageCropped = null;
      if (this.hasChange[this.imgLocation]) {
        switch (this.imgLocation) {
          case 'embed_icon':
            this.embedIcon = [];
            break;
          case 'embed_thumbnail':
            this.embedThumbnail = [];
            break;
          case 'thumbnail':
            this.thumbnail = [];
            break;
          case 'background':
            this.background = [];
            break;
        }
      }
    },
    handleOk() {
      this.typeLoading = 'submit';
      this.isLoading = true;
      setTimeout(() => {
        switch (this.imgLocation) {
          case 'embed_icon':
            this.embedIcon = [
              {
                ...this.embedIcon[0],
                preview: this.imageCropped,
                thumbUrl: this.imageCropped,
              },
            ];
            break;
          case 'embed_thumbnail':
            this.embedThumbnail = [
              {
                ...this.embedThumbnail[0],
                preview: this.imageCropped,
                thumbUrl: this.imageCropped,
              },
            ];
            break;
          case 'thumbnail':
            this.thumbnail = [
              {
                ...this.thumbnail[0],
                preview: this.imageCropped,
                thumbUrl: this.imageCropped,
              },
            ];
            break;
          case 'background':
            this.background = [
              {
                ...this.background[0],
                preview: this.imageCropped,
                thumbUrl: this.imageCropped,
              },
            ];
            break;
        }
        this.$set(this.hasCropped, this.imgLocation, true);
        this.previewVisible = false;
        this.isLoading = false;
      }, 300);
    },
    handlePreview(file, location) {
      this.imgLocation = location;
      this.previewImage = null;
      this.$nextTick(async () => {
        this.isLoadingCropper = true;
        if (this.hasChange[location] || this.hasCropped[location]) {
          if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
          }
          this.previewImage = file.preview;
        } else {
          this.previewImage = file.url;
        }
        this.previewVisible = true;
      });
    },
    handleChange({ fileList }, location) {
      this.imgLocation = location;
      if (!empty(fileList)) {
        this.$set(this.hasChange, location, true);
        const image = new Image();
        image.src = URL.createObjectURL(fileList[0].originFileObj);
        image.onload = () => {
          // const { minWidth, minHeight } = this.defaultSize();
          // if (image.height < minHeight || image.width < minWidth) {
          //   this.$notification['error']({
          //     message: 'Image error',
          //     description: `Please choose image have size greater ${minHeight}px,${minWidth}px (height,width)`,
          //   });
          //   return;
          // }
          switch (location) {
            case 'embed_icon':
              this.embedIcon = fileList;
              break;
            case 'embed_thumbnail':
              this.embedThumbnail = fileList;
              break;
            case 'thumbnail':
              this.thumbnail = fileList;
              break;
            case 'background':
              this.background = fileList;
              break;
          }
          this.handlePreview(fileList[0], location);
        };
      } else {
        switch (location) {
          case 'embed_icon':
            this.embedIcon = [];
            this.form.setFieldsValue({
              embed_icon: {},
            });
            break;
          case 'embed_thumbnail':
            this.embedThumbnail = [];
            this.form.setFieldsValue({
              embed_thumbnail: {},
            });
            break;
          case 'thumbnail':
            this.thumbnail = [];
            this.form.setFieldsValue({
              thumbnail: {},
            });
            break;
          case 'background':
            this.background = [];
            this.form.setFieldsValue({
              background: {},
            });
            break;
        }
      }
    },
    beforeUpload(file) {
      return false;
    },
    onCropperReady() {
      this.isLoadingCropper = false;
    },
    onChangePlayerEmbed(val) {
      this.playerembed = this.form.getFieldValue('playerembed');
    },
    showEmbedPreview() {
      if (this.showPreview) {
        this.showPreview = false;
      } else {
        this.playerembed = this.form.getFieldValue('playerembed');
        this.showPreview = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
<style lang="scss">
.category {
  &.mobile {
    .editr--toolbar {
      height: 100%;
      flex-wrap: wrap;
      .vw-btn-separator {
        display: none;
      }
    }
    .ant-card-body {
      .ant-upload-list-item-actions {
        left: 25px;
        top: calc(100% + 20px);
        opacity: 1;
        i {
          color: rgba(#000, 0.8);
          opacity: 1;
          font-size: 20px;
        }
        > a {
          margin-right: 10px;
        }
      }
    }
  }
  .ant-card-body {
    .embedIcon {
      .ant-upload-list-picture-card .ant-upload-list-item,
      .ant-upload-list-picture-card-container,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
        width: 100%;
        height: 100%;
        max-width: 937px;
        max-height: 341px;
      }
    }
    .background {
      .ant-upload-list-picture-card .ant-upload-list-item,
      .ant-upload-list-picture-card-container,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
        width: 100%;
        height: 100%;
        max-width: 190px;
        max-height: 250px;
      }
    }
    .ant-upload-list-item-actions {
      i {
        font-size: 26px;
        width: auto;
      }
    }
  }
}
.ant-modal-root.editProfile .ant-modal-body {
  .ant-spin-spinning {
    display: block;
    margin: auto;
  }
}
.select-from-gallery {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  > span {
    width: initial;
  }
}
</style>
